// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageView_container__3rnqy","container_hidden":"ImageView_container_hidden__1K7oR","imgWrapper":"ImageView_imgWrapper__1mK5q","close":"ImageView_close__2btGJ"};